import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import SubHeader from "../components/SubHeader";

const CustomerDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isToggle, setIsToggle] = useState(false);
  const { state } = useLocation();
  const { isLoading2, getInvoiceData } = useSelector(
    (state) => state?.maintainedReducer,
  );

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  if (isLoading2) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="customer-detail" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              <div className="ct_mb_30">
                <diiv>

                <SubHeader />
                </diiv>


                <div class="row mb-2 mt-4">
                 
                
                  <div class="col-xxl-6 col-xl-6 col-lg-6 col-sm-6 mb-4">
                    <div class="ct_white_bg ct_dash_card">
                      <div class="">
                        <div>
                       <div class="d-flex justify-content-between gap-2 mb-2 align-items-center">
                           <h6 class="mb-0 ct_fs_22 ct_text_dark mb-2"> John Doe</h6>
                           <div class="ct_custom_badge ms-auto" style={{backgroundColor: "rgb(203, 247, 255)" ,color: "rgb(35, 192, 232)"}}>
                          
                            <small class="ct_ff_ProximaNova_regular">Boat Captain</small></div>
                       </div>


                        <div class=" mb-3 mt-4 d-flex flex-wrap  gap-2 justify-content-between align-items-center">
                            <span class="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
                  <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.96094 6.42833L7.7776 10.3067C8.5801 10.8408 8.98094 11.1083 9.41427 11.2125C9.7976 11.3042 10.1968 11.3042 10.5793 11.2125C11.0126 11.1083 11.4134 10.8408 12.2159 10.3067L18.0326 6.42833M5.96094 16.25H14.0326C15.4326 16.25 16.1326 16.25 16.6676 15.9775C17.1377 15.7377 17.5198 15.3553 17.7593 14.885C18.0326 14.35 18.0326 13.65 18.0326 12.25V7.75C18.0326 6.35 18.0326 5.65 17.7601 5.115C17.5204 4.64462 17.138 4.26218 16.6676 4.0225C16.1326 3.75 15.4326 3.75 14.0326 3.75H5.96094C4.56094 3.75 3.86094 3.75 3.32594 4.0225C2.85586 4.26232 2.47373 4.64474 2.23427 5.115C1.96094 5.65 1.96094 6.35 1.96094 7.75V12.25C1.96094 13.65 1.96094 14.35 2.23344 14.885C2.47312 15.3554 2.85555 15.7378 3.32594 15.9775C3.86094 16.25 4.56094 16.25 5.96094 16.25Z" stroke="#808C9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

Email:

                               </span>
                               <span className="ct_fs_16 ct_fw_600 ct_text_para"> john.doe@email.com</span>
                                
                        </div>
                             <div class="  d-flex flex-wrap gap-2 justify-content-between align-items-center">
                            <span class="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
            <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.64299 6.57296C4.40487 5.00171 5.51362 3.58796 7.20737 3.06921C7.5081 2.97717 7.83262 3.00332 8.11473 3.14234C8.39684 3.28137 8.61528 3.52278 8.72549 3.81734L9.26862 5.26734C9.35594 5.50058 9.3716 5.75459 9.31358 5.99679C9.25556 6.239 9.12652 6.45835 8.94299 6.62671L7.32737 8.10859C7.24754 8.18168 7.18806 8.27425 7.15475 8.37723C7.12145 8.48022 7.11546 8.59009 7.13737 8.69609L7.15174 8.76109L7.19174 8.92421C7.22737 9.06171 7.28112 9.25546 7.35674 9.48671C7.50674 9.94609 7.74612 10.5636 8.10237 11.1805C8.45862 11.7973 8.87362 12.3136 9.19612 12.673C9.36422 12.8599 9.53978 13.0401 9.72237 13.213L9.77237 13.2592C9.85318 13.3308 9.95115 13.3802 10.0567 13.4027C10.1623 13.4251 10.2719 13.4198 10.3749 13.3873L12.4661 12.7292C12.7037 12.6545 12.9582 12.6525 13.197 12.7235C13.4357 12.7944 13.6478 12.935 13.8061 13.1273L14.7955 14.3286C15.208 14.8286 15.1592 15.5636 14.6849 16.0055C13.3886 17.2136 11.6061 17.4617 10.3661 16.4642C8.84657 15.238 7.56529 13.7429 6.58612 12.0536C5.59975 10.3648 4.94054 8.50591 4.64299 6.57296ZM8.44674 8.77796L9.78799 7.54796C10.155 7.21123 10.4131 6.77253 10.5292 6.28813C10.6452 5.80372 10.6139 5.2957 10.4392 4.82921L9.89549 3.37921C9.67366 2.78679 9.23425 2.30127 8.66683 2.02163C8.0994 1.74198 7.44669 1.68926 6.84174 1.87421C4.73862 2.51859 3.04987 4.40421 3.40737 6.75984C3.72828 8.84852 4.44009 10.858 5.50549 12.683C6.56162 14.5047 7.94352 16.1169 9.58237 17.4392C11.4417 18.933 13.9255 18.4236 15.5374 16.9205C15.9988 16.4907 16.2789 15.9011 16.3204 15.2719C16.3618 14.6427 16.1616 14.0214 15.7605 13.5348L14.7711 12.3336C14.4545 11.9488 14.0302 11.6675 13.5525 11.5256C13.0749 11.3837 12.5658 11.3878 12.0905 11.5373L10.3549 12.0836C10.2772 12.0037 10.2011 11.9222 10.1267 11.8392C9.76992 11.4447 9.45432 11.0147 9.18487 10.5561C8.92225 10.0933 8.7076 9.60497 8.54424 9.09859C8.50955 8.9926 8.47704 8.88591 8.44674 8.77859" fill="#808C9D"/>
</svg>


Contact No.:

                               </span>
                               <span className="ct_fs_16 ct_fw_600 ct_text_para"> +1 123-456-7890</span>
                                
                        </div>
                        </div>
                    
                      </div>
                     
                    </div>
                  </div>
                <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                    <div class="ct_white_bg ct_dash_card">
                      <div class="d-flex align-items-center gap-3 justify-content-between">
                        <div>
                          <p class="mb-0">Total Boats</p>
                          <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                            10293
                          </h3>
                        </div>
                        <div class="ct_dash_icon">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_52_1254)">
                              <path d="M5.7526 22.5833C6.66927 22.5 7.58594 22.8333 8.33594 23.5C9.2526 24.4167 10.7526 24.4167 11.7526 23.5C12.5859 22.9167 13.5026 22.5833 14.5026 22.5833C15.5026 22.5 16.5026 22.8333 17.2526 23.5C17.7526 23.9167 18.3359 24.1667 19.0026 24.1667C19.6693 24.1667 20.2526 23.9167 20.7526 23.5C21.5859 22.8333 22.5859 22.5 23.5859 22.5C24.5859 22.5 25.5859 22.8333 26.4193 23.5C26.9193 23.9167 27.6693 24.1667 28.3359 24.1667V25.8333C27.2526 25.9167 26.1693 25.5833 25.3359 24.8333C24.8359 24.4167 24.0859 24.1667 23.4193 24.1667C22.8359 24.1667 22.1693 24.4167 21.6693 24.8333C20.1693 26.1667 17.8359 26.1667 16.2526 24.8333C15.7526 24.4167 15.1693 24.1667 14.5026 24.1667C13.9193 24.1667 13.3359 24.4167 12.8359 24.8333C11.2526 26.1667 9.0026 26.1667 7.41927 24.8333C7.0026 24.4167 6.33594 24.1667 5.7526 24.1667C5.16927 24.1667 4.58594 24.4167 4.16927 24.8333C3.41927 25.4167 2.58594 25.75 1.66927 25.8333V24.1667C2.5026 24.1667 2.66927 23.8333 3.08594 23.5C3.83594 22.9167 4.7526 22.5833 5.7526 22.5833Z" fill="#23C0E8"></path>
                              <path d="M25.0026 19.167C25.0026 18.667 24.5859 18.3337 24.0859 18.3337H3.33594L6.2526 20.917H6.08594C5.41927 20.917 4.7526 21.0837 4.2526 21.3337L2.16927 19.5003L2.0026 19.3337C1.41927 18.667 1.5026 17.5837 2.16927 17.0003C2.5026 16.8337 2.83594 16.667 3.2526 16.667H24.0859C25.5026 16.667 26.5859 17.7503 26.5859 19.167V21.8337C26.1693 21.417 25.5859 21.167 25.0026 20.917V19.167Z" fill="#23C0E8"></path>
                              <path d="M22.5848 15.8335H17.5015V9.33352C17.5015 8.83352 17.7515 8.33352 18.1682 8.00019C18.9182 7.41686 20.0015 7.58352 20.5015 8.33352L23.9182 13.2502C24.2515 13.7502 24.2515 14.4169 24.0015 15.0002C23.7515 15.5002 23.1682 15.8335 22.5848 15.8335ZM19.0848 9.33352L19.1682 14.1669H22.5848L19.0848 9.33352Z" fill="#23C0E8"></path>
                              <path d="M8.33073 14.9997C7.9974 14.4997 7.9974 13.833 8.33073 13.333L13.5807 4.66634C13.9141 4.16634 14.4141 3.83301 14.9974 3.83301C15.9141 3.83301 16.6641 4.58301 16.6641 5.49967V15.833H9.7474C9.16406 15.833 8.58073 15.4997 8.33073 14.9997ZM15.0807 5.49967L9.7474 14.2497H15.0807V5.49967Z" fill="#23C0E8"></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_52_1254">
                                <rect width="30" height="30" fill="#23C0E8" transform="matrix(-1 0 0 1 30 0)"></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div class="mt-auto">
                        <span class="mb-0 d-flex align-items-center gap-2 ct_mt_34 ct_ff_ProximaNova_semibold text-nowrap"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.2649 0L16.5982 2.29L11.6259 7.17L7.55019 3.17L0 10.59L1.43668 12L7.55019 6L11.6259 10L18.0451 3.71L20.3784 6V0H14.2649Z" fill="#00B69B"></path></svg><span class="ct_text_clr_00B69B ct_ff_ProximaNova_semibold text-nowrap">
                            1.3%</span>
                          Up from past week</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xxl-3 col-xl-6 col-lg-6 col-sm-6 mb-4">
                    <div class="ct_white_bg ct_dash_card active">
                      <div class="d-flex align-items-center gap-3 justify-content-between">
                        <div>
                          <p class="mb-0">Total Revenue</p>
                          <h3 class="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                           $45,000
                          </h3>
                        </div>
                        <div class="ct_dash_icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.6391 16.0001C23.5205 15.0624 22.0984 14.5647 20.6391 14.6001H11.2591C10.8315 14.6109 10.406 14.5353 10.0082 14.3778C9.61048 14.2203 9.24858 13.9842 8.94421 13.6836C8.63984 13.3829 8.39926 13.024 8.23687 12.6282C8.07449 12.2324 7.99363 11.8079 7.99915 11.3801C7.98872 11.2136 7.98872 11.0466 7.99915 10.8801C8.12526 10.1157 8.52607 9.42367 9.12633 8.93388C9.72659 8.4441 10.485 8.19029 11.2591 8.22012H20.4991C21.2529 8.21945 21.9823 8.48653 22.5574 8.97372C23.1325 9.46091 23.5159 10.1365 23.6391 10.8801H26.6391C26.5136 9.33799 25.8122 7.89959 24.6746 6.8509C23.537 5.80221 22.0464 5.22004 20.4991 5.22012H17.3391V0.620117H14.8391V5.22012H11.2591C9.71191 5.22004 8.22131 5.80221 7.08368 6.8509C5.94606 7.89959 5.24474 9.33799 5.11915 10.8801C5.10872 11.0466 5.10872 11.2136 5.11915 11.3801C5.11915 12.1864 5.27796 12.9849 5.58653 13.7298C5.89509 14.4747 6.34736 15.1516 6.91751 15.7218C8.06899 16.8732 9.63072 17.5201 11.2591 17.5201H20.7391C21.1634 17.5094 21.5856 17.5838 21.9807 17.7388C22.3758 17.8939 22.7358 18.1264 23.0396 18.4228C23.3435 18.7191 23.5849 19.0733 23.7497 19.4644C23.9145 19.8555 23.9993 20.2757 23.9991 20.7001C24.0185 20.9264 24.0185 21.1539 23.9991 21.3801C23.8404 22.0838 23.447 22.7126 22.8837 23.1633C22.3204 23.6139 21.6206 23.8597 20.8991 23.8601H11.4991C10.7777 23.8597 10.0779 23.6139 9.51462 23.1633C8.9513 22.7126 8.55795 22.0838 8.39915 21.3801H5.37915C5.55102 22.8828 6.26975 24.2698 7.39838 25.2767C8.52701 26.2836 9.98664 26.8401 11.4991 26.8401H14.8391V31.3801H17.3391V26.8401H20.7391C22.2517 26.8401 23.7113 26.2836 24.8399 25.2767C25.9685 24.2698 26.6873 22.8828 26.8591 21.3801V20.7001C26.8567 19.8018 26.6566 18.915 26.2729 18.1027C25.8892 17.2904 25.3315 16.5726 24.6391 16.0001Z" fill="white"></path>
</svg>

                        </div>
                      </div>
                      <div class="mt-auto">
                        <span class="mb-0 d-flex align-items-center gap-2 ct_mt_34 ct_ff_ProximaNova_semibold text-nowrap">
                          <svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.2649 0L16.5982 2.29L11.6259 7.17L7.55019 3.17L0 10.59L1.43668 12L7.55019 6L11.6259 10L18.0451 3.71L20.3784 6V0H14.2649Z" fill="#fff"></path></svg>
                          <span class="ct_ff_ProximaNova_semibold text-nowrap">
                           1.3% Up from past week</span>
                      </span></div>
                    </div>
                  </div>
                
                </div>
   

   <h5 className="ct_fs_20 ct_fw_600 ct_mt_35">
    Boats Owned
   </h5>
   <div class="row mt-3">
   
  
      {/* ══ CARD 1 — Dock Delta ══ */}
  <div class="col-12 col-sm-6 col-lg-4 col-xl-3 ct_mb_30">
         <div class="boat-detail-card">
   
      {/* Dark Header */}
      <div class="boat-card-header">
        <div class="header-left d-flex align-items-center gap-3">
        
          <div class="boat-no-block d-grid">
            <span class="boat-no-label ct_fs_13 ct_fw_400 ct_text-clr_CAD5E2">Boat No.</span>
            <span class="boat-no-value ct_fs_24 ct_fw_700 text-white">23</span>
          </div>
        </div>
   
       
      </div>
   
      {/* Body */}
      <div class="boat-card-body">
   
        <div class="info-row ">
          <div class="info-icon-wrap">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1268)">
  <path d="M8.34961 7.09082V9.74285" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.34961 1.39258V3.48024" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.2219 9.04757V4.87224C13.2219 4.50312 13.0753 4.14912 12.8143 3.88811C12.5533 3.6271 12.1993 3.48047 11.8301 3.48047H4.87127C4.50215 3.48047 4.14814 3.6271 3.88713 3.88811C3.62613 4.14912 3.47949 4.50312 3.47949 4.87224V9.04757" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.4856 13.9183C14.2342 12.655 14.624 11.2114 14.613 9.74302L8.91506 7.21069C8.73716 7.13166 8.54466 7.09082 8.35 7.09082C8.15533 7.09082 7.96283 7.13166 7.78493 7.21069L2.08701 9.74302C2.05479 11.7219 2.75069 13.6437 4.04245 15.1431" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.39258 14.6148C1.81011 14.9628 2.22764 15.3107 3.1323 15.3107C4.87202 15.3107 4.87202 13.9189 6.61173 13.9189C7.51639 13.9189 7.93392 14.2669 8.35145 14.6148C8.76899 14.9628 9.18652 15.3107 10.0912 15.3107C11.8309 15.3107 11.8309 13.9189 13.5706 13.9189C14.4753 13.9189 14.8928 14.2669 15.3103 14.6148" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1268">
  <rect width="16.7013" height="16.7013" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          </div>
          <div class="info-text">
            <div class="info-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Boat Name</div>
            <div class="info-value  ct_fs_15 ct_fw_600 ct_text_black">Yoko Littie</div>
          </div>
        </div>
   
   
      </div>
   
      {/* Footer */}
      <div class="boat-card-footer">
        <span class="status-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Status</span>
        <span class="active-badge badge">
         <svg class="" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1290)">
  <path d="M4.30338 7.37336L6.9348 9.56621L10.4433 5.18052M7.37336 13.5133C6.56705 13.5133 5.76864 13.3545 5.0237 13.046C4.27877 12.7374 3.6019 12.2851 3.03175 11.715C2.4616 11.1448 2.00934 10.468 1.70078 9.72303C1.39221 8.97809 1.2334 8.17968 1.2334 7.37336C1.2334 6.56705 1.39221 5.76864 1.70078 5.0237C2.00934 4.27877 2.4616 3.6019 3.03175 3.03175C3.6019 2.4616 4.27877 2.00934 5.0237 1.70078C5.76864 1.39221 6.56705 1.2334 7.37336 1.2334C9.00179 1.2334 10.5635 1.88029 11.715 3.03175C12.8664 4.18322 13.5133 5.74494 13.5133 7.37336C13.5133 9.00179 12.8664 10.5635 11.715 11.715C10.5635 12.8664 9.00179 13.5133 7.37336 13.5133Z" stroke="#009C35" stroke-width="1.15124"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1290">
  <rect width="13.9794" height="13.9794" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          Assigned
        </span>
      </div>
   
    </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3 ct_mb_30">
         <div class="boat-detail-card">
   
      {/* Dark Header */}
      <div class="boat-card-header">
        <div class="header-left d-flex align-items-center gap-3">
       
          <div class="boat-no-block d-grid">
            <span class="boat-no-label ct_fs_13 ct_fw_400 ct_text-clr_CAD5E2">Boat No.</span>
            <span class="boat-no-value ct_fs_24 ct_fw_700 text-white">23</span>
          </div>
        </div>
   
      
      </div>
   
      {/* Body */}
      <div class="boat-card-body">
   
        <div class="info-row ">
          <div class="info-icon-wrap">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1268)">
  <path d="M8.34961 7.09082V9.74285" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.34961 1.39258V3.48024" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.2219 9.04757V4.87224C13.2219 4.50312 13.0753 4.14912 12.8143 3.88811C12.5533 3.6271 12.1993 3.48047 11.8301 3.48047H4.87127C4.50215 3.48047 4.14814 3.6271 3.88713 3.88811C3.62613 4.14912 3.47949 4.50312 3.47949 4.87224V9.04757" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.4856 13.9183C14.2342 12.655 14.624 11.2114 14.613 9.74302L8.91506 7.21069C8.73716 7.13166 8.54466 7.09082 8.35 7.09082C8.15533 7.09082 7.96283 7.13166 7.78493 7.21069L2.08701 9.74302C2.05479 11.7219 2.75069 13.6437 4.04245 15.1431" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.39258 14.6148C1.81011 14.9628 2.22764 15.3107 3.1323 15.3107C4.87202 15.3107 4.87202 13.9189 6.61173 13.9189C7.51639 13.9189 7.93392 14.2669 8.35145 14.6148C8.76899 14.9628 9.18652 15.3107 10.0912 15.3107C11.8309 15.3107 11.8309 13.9189 13.5706 13.9189C14.4753 13.9189 14.8928 14.2669 15.3103 14.6148" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1268">
  <rect width="16.7013" height="16.7013" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          </div>
          <div class="info-text">
            <div class="info-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Boat Name</div>
            <div class="info-value  ct_fs_15 ct_fw_600 ct_text_black">Yoko Littie</div>
          </div>
        </div>
   
   
      </div>
   
      {/* Footer */}
      <div class="boat-card-footer">
        <span class="status-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Status</span>
        <span class="inactive-badge badge">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.40731 9.90216H7.57226V6.40731H6.40731V9.90216ZM7.40509 5.07519C7.51654 4.96336 7.57226 4.82492 7.57226 4.65989C7.57226 4.49485 7.51634 4.35661 7.40451 4.24516C7.29267 4.13372 7.15443 4.0778 6.98978 4.07741C6.82514 4.07702 6.6869 4.13294 6.57506 4.24516C6.46323 4.35739 6.40731 4.49563 6.40731 4.65989C6.40731 4.82414 6.46323 4.96258 6.57506 5.07519C6.6869 5.1878 6.82514 5.24353 6.98978 5.24236C7.15443 5.2412 7.29287 5.18528 7.40509 5.07461M6.98978 12.8145C6.18403 12.8145 5.42681 12.6615 4.71813 12.3555C4.00946 12.0495 3.393 11.6346 2.86878 11.1108C2.34455 10.587 1.92963 9.9705 1.62403 9.26143C1.31842 8.55237 1.16543 7.79515 1.16504 6.98978C1.16465 6.18442 1.31765 5.4272 1.62403 4.71813C1.93041 4.00907 2.34533 3.39262 2.86878 2.86878C3.39223 2.34494 4.00868 1.93002 4.71813 1.62403C5.42759 1.31804 6.1848 1.16504 6.98978 1.16504C7.79476 1.16504 8.55198 1.31804 9.26144 1.62403C9.97089 1.93002 10.5873 2.34494 11.1108 2.86878C11.6342 3.39262 12.0494 4.00907 12.3561 4.71813C12.6629 5.4272 12.8157 6.18442 12.8145 6.98978C12.8134 7.79515 12.6604 8.55237 12.3555 9.26143C12.0507 9.9705 11.6358 10.587 11.1108 11.1108C10.5858 11.6346 9.96934 12.0497 9.26144 12.3561C8.55353 12.6625 7.79632 12.8153 6.98978 12.8145ZM6.98978 11.6496C8.29064 11.6496 9.39249 11.1982 10.2953 10.2953C11.1982 9.39249 11.6496 8.29064 11.6496 6.98978C11.6496 5.68892 11.1982 4.58708 10.2953 3.68424C9.39249 2.78141 8.29064 2.32999 6.98978 2.32999C5.68893 2.32999 4.58708 2.78141 3.68424 3.68424C2.78141 4.58708 2.32999 5.68892 2.32999 6.98978C2.32999 8.29064 2.78141 9.39249 3.68424 10.2953C4.58708 11.1982 5.68893 11.6496 6.98978 11.6496Z" fill="#CB0B03"/>
  </svg>
  
  
          Unassigned
        </span>
      </div>
   
    </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3 ct_mb_30">
         <div class="boat-detail-card">
   
      {/* Dark Header */}
      <div class="boat-card-header">
        <div class="header-left d-flex align-items-center gap-3">
         
          <div class="boat-no-block d-grid">
            <span class="boat-no-label ct_fs_13 ct_fw_400 ct_text-clr_CAD5E2">Boat No.</span>
            <span class="boat-no-value ct_fs_24 ct_fw_700 text-white">23</span>
          </div>
        </div>
   
       
      </div>
   
      {/* Body */}
      <div class="boat-card-body">
   
        <div class="info-row">
          <div class="info-icon-wrap">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1268)">
  <path d="M8.34961 7.09082V9.74285" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.34961 1.39258V3.48024" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.2219 9.04757V4.87224C13.2219 4.50312 13.0753 4.14912 12.8143 3.88811C12.5533 3.6271 12.1993 3.48047 11.8301 3.48047H4.87127C4.50215 3.48047 4.14814 3.6271 3.88713 3.88811C3.62613 4.14912 3.47949 4.50312 3.47949 4.87224V9.04757" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.4856 13.9183C14.2342 12.655 14.624 11.2114 14.613 9.74302L8.91506 7.21069C8.73716 7.13166 8.54466 7.09082 8.35 7.09082C8.15533 7.09082 7.96283 7.13166 7.78493 7.21069L2.08701 9.74302C2.05479 11.7219 2.75069 13.6437 4.04245 15.1431" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.39258 14.6148C1.81011 14.9628 2.22764 15.3107 3.1323 15.3107C4.87202 15.3107 4.87202 13.9189 6.61173 13.9189C7.51639 13.9189 7.93392 14.2669 8.35145 14.6148C8.76899 14.9628 9.18652 15.3107 10.0912 15.3107C11.8309 15.3107 11.8309 13.9189 13.5706 13.9189C14.4753 13.9189 14.8928 14.2669 15.3103 14.6148" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1268">
  <rect width="16.7013" height="16.7013" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          </div>
          <div class="info-text">
            <div class="info-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Boat Name</div>
            <div class="info-value  ct_fs_15 ct_fw_600 ct_text_black">Yoko Littie</div>
          </div>
        </div>
   
     
   
      </div>
   
      {/* Footer */}
      <div class="boat-card-footer">
        <span class="status-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Status</span>
        <span class="active-badge badge">
         <svg class="" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1290)">
  <path d="M4.30338 7.37336L6.9348 9.56621L10.4433 5.18052M7.37336 13.5133C6.56705 13.5133 5.76864 13.3545 5.0237 13.046C4.27877 12.7374 3.6019 12.2851 3.03175 11.715C2.4616 11.1448 2.00934 10.468 1.70078 9.72303C1.39221 8.97809 1.2334 8.17968 1.2334 7.37336C1.2334 6.56705 1.39221 5.76864 1.70078 5.0237C2.00934 4.27877 2.4616 3.6019 3.03175 3.03175C3.6019 2.4616 4.27877 2.00934 5.0237 1.70078C5.76864 1.39221 6.56705 1.2334 7.37336 1.2334C9.00179 1.2334 10.5635 1.88029 11.715 3.03175C12.8664 4.18322 13.5133 5.74494 13.5133 7.37336C13.5133 9.00179 12.8664 10.5635 11.715 11.715C10.5635 12.8664 9.00179 13.5133 7.37336 13.5133Z" stroke="#009C35" stroke-width="1.15124"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1290">
  <rect width="13.9794" height="13.9794" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          Assigned
        </span>
      </div>
   
    </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3 ct_mb_30">
         <div class="boat-detail-card">
   
      {/* Dark Header */}
      <div class="boat-card-header">
        <div class="header-left d-flex align-items-center gap-3">
         
          <div class="boat-no-block d-grid">
            <span class="boat-no-label ct_fs_13 ct_fw_400 ct_text-clr_CAD5E2">Boat No.</span>
            <span class="boat-no-value ct_fs_24 ct_fw_700 text-white">23</span>
          </div>
        </div>
   
    
      </div>
   
      {/* Body */}
      <div class="boat-card-body">
   
        <div class="info-row ">
          <div class="info-icon-wrap">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1268)">
  <path d="M8.34961 7.09082V9.74285" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.34961 1.39258V3.48024" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.2219 9.04757V4.87224C13.2219 4.50312 13.0753 4.14912 12.8143 3.88811C12.5533 3.6271 12.1993 3.48047 11.8301 3.48047H4.87127C4.50215 3.48047 4.14814 3.6271 3.88713 3.88811C3.62613 4.14912 3.47949 4.50312 3.47949 4.87224V9.04757" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.4856 13.9183C14.2342 12.655 14.624 11.2114 14.613 9.74302L8.91506 7.21069C8.73716 7.13166 8.54466 7.09082 8.35 7.09082C8.15533 7.09082 7.96283 7.13166 7.78493 7.21069L2.08701 9.74302C2.05479 11.7219 2.75069 13.6437 4.04245 15.1431" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.39258 14.6148C1.81011 14.9628 2.22764 15.3107 3.1323 15.3107C4.87202 15.3107 4.87202 13.9189 6.61173 13.9189C7.51639 13.9189 7.93392 14.2669 8.35145 14.6148C8.76899 14.9628 9.18652 15.3107 10.0912 15.3107C11.8309 15.3107 11.8309 13.9189 13.5706 13.9189C14.4753 13.9189 14.8928 14.2669 15.3103 14.6148" stroke="#013760" stroke-width="1.39177" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1268">
  <rect width="16.7013" height="16.7013" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          </div>
          <div class="info-text">
            <div class="info-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Boat Name</div>
            <div class="info-value  ct_fs_15 ct_fw_600 ct_text_black">Yoko Littie</div>
          </div>
        </div>
   
      
   
      </div>
   
      {/* Footer */}
      <div class="boat-card-footer">
        <span class="status-label ct_fs_13 ct_fw_400 ct_text_clr_62748E">Status</span>
        <span class="active-badge badge">
         <svg class="" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_271_1290)">
  <path d="M4.30338 7.37336L6.9348 9.56621L10.4433 5.18052M7.37336 13.5133C6.56705 13.5133 5.76864 13.3545 5.0237 13.046C4.27877 12.7374 3.6019 12.2851 3.03175 11.715C2.4616 11.1448 2.00934 10.468 1.70078 9.72303C1.39221 8.97809 1.2334 8.17968 1.2334 7.37336C1.2334 6.56705 1.39221 5.76864 1.70078 5.0237C2.00934 4.27877 2.4616 3.6019 3.03175 3.03175C3.6019 2.4616 4.27877 2.00934 5.0237 1.70078C5.76864 1.39221 6.56705 1.2334 7.37336 1.2334C9.00179 1.2334 10.5635 1.88029 11.715 3.03175C12.8664 4.18322 13.5133 5.74494 13.5133 7.37336C13.5133 9.00179 12.8664 10.5635 11.715 11.715C10.5635 12.8664 9.00179 13.5133 7.37336 13.5133Z" stroke="#009C35" stroke-width="1.15124"/>
  </g>
  <defs>
  <clipPath id="clip0_271_1290">
  <rect width="13.9794" height="13.9794" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  
          Assigned
        </span>
      </div>
   
    </div>
        </div>
   
  
  
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetail;
